enum FileType {
  FILE = "file",
  DIRECTORY = "directory",
}

export default FileType;
